import React, { useCallback } from "react"
import { StyleSheet, View } from "react-native"

import Collapsible from "../../../common/Collapsible"
import ChoiceRow from "./ChoiceRow"
import ItemRow from "./ItemRow"
import OptionRow from "./OptionRow"

export default function MenuItem(props) {
  const renderHeader = useCallback(
    item => headerProps => (
      <OptionRow
        item={item}
        onStatusChange={props.onStatusChange}
        isFlooid={props.isFlooid}
        {...headerProps}
      />
    ),
    [props],
  )

  return (
    <View style={styles.main}>
      <ItemRow
        item={props.item}
        onPress={() => {}}
        onStatusChange={props.onStatusChange}
        onStockChange={props.onStockChange}
        isFlooid={props.isFlooid}
      />
      <View style={styles.content}>
        {props.item.choiceGroups.map(g => (
          <Collapsible key={g._id} RenderHeader={renderHeader(g)}>
            <View style={styles.content}>
              {g.items.map((choice, index) => (
                <ChoiceRow
                  key={index}
                  item={choice}
                  onPress={props.onPress}
                  onStatusChange={props.onStatusChange}
                  onStockChange={props.onStockChange}
                  isFlooid={props.isFlooid}
                  choiceGroupType={g.type || ""}
                />
              ))}
            </View>
          </Collapsible>
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
  },

  content: {
    marginLeft: 20,
  },
})
